import type { EventSportType, WorkoutType } from '../services/api';

/**
 * Static workout types — mirrors `workout_types` table / WorkoutTypeSeeder.
 * TODO: remove when `/api/v1/mobile/workout/workout-types` is stable in all envs.
 */
export const STATIC_WORKOUT_TYPES: WorkoutType[] = [
  { id: 1, name: 'دویدن', english_name: 'Run', icon: 'icon' },
  { id: 2, name: 'دوچرخه‌سواری', english_name: 'Bike', icon: 'icon' },
  { id: 8, name: 'دوچرخه‌سواری کوهستان', english_name: 'Mountain Bike', icon: 'icon' },
  { id: 3, name: 'شنا', english_name: 'Swim', icon: 'icon' },
  { id: 4, name: 'تمرین چندگانه (شنا، دو، دوچرخه)', english_name: 'Brick', icon: 'icon' },
  { id: 5, name: 'تمرین ترکیبی (کراس ترینینگ)', english_name: 'Crosstrain', icon: 'icon' },
  { id: 6, name: 'مسابقه', english_name: 'Race', icon: 'icon' },
  { id: 7, name: 'روز استراحت', english_name: 'Day Off', icon: 'icon' },
  { id: 9, name: 'تمرین قدرتی', english_name: 'Strength', icon: 'icon' },
  { id: 10, name: 'سفارشی', english_name: 'Custom', icon: 'icon' },
  { id: 11, name: 'اسکی صحرانوردی', english_name: 'XC-Ski', icon: 'icon' },
  { id: 12, name: 'قایق‌رانی', english_name: 'Rowing', icon: 'icon' },
  { id: 13, name: 'سایر', english_name: 'Other', icon: 'icon' },
  { id: 14, name: 'پیاده‌روی', english_name: 'Walk', icon: 'icon' },
];

/**
 * Static event sport types — mirrors `sport_types` table (parent_id = -1 roots + child).
 * TODO: remove when `/api/v1/mobile/event/sport-types` is stable in all envs.
 */
export const STATIC_EVENT_SPORT_TYPES: EventSportType[] = [
  {
    id: 1,
    name: 'cycling',
    persian_name: 'دوچرخه سواری',
    child: [
      { id: 8, name: 'Road Running', persian_name: '', child: [] },
      { id: 9, name: 'Trail Running', persian_name: '', child: [] },
      { id: 10, name: 'Track Running', persian_name: '', child: [] },
      { id: 11, name: 'Cross Country', persian_name: '', child: [] },
      { id: 12, name: 'Running', persian_name: '', child: [] },
    ],
  },
  {
    id: 2,
    name: 'swimming',
    persian_name: 'شنا',
    child: [
      { id: 13, name: 'Road Bike', persian_name: '', child: [] },
      { id: 14, name: 'Mountain Bike', persian_name: '', child: [] },
      { id: 15, name: 'Cyclocross', persian_name: '', child: [] },
      { id: 16, name: 'Track Cycling', persian_name: '', child: [] },
      { id: 17, name: 'Cycling', persian_name: '', child: [] },
    ],
  },
  {
    id: 3,
    name: 'running',
    persian_name: 'دوندگی',
    child: [
      { id: 18, name: 'Open Water Swim', persian_name: '', child: [] },
      { id: 19, name: 'Lap Swim', persian_name: '', child: [] },
    ],
  },
  {
    id: 4,
    name: 'multisport',
    persian_name: 'ورزش های چندگانه',
    child: [
      { id: 20, name: 'Triathlon', persian_name: '', child: [] },
      { id: 21, name: 'Xterra', persian_name: '', child: [] },
      { id: 22, name: 'Duathlon', persian_name: '', child: [] },
      { id: 23, name: 'Aquabike', persian_name: '', child: [] },
      { id: 24, name: 'Aquathon', persian_name: '', child: [] },
      { id: 25, name: 'Multisport', persian_name: '', child: [] },
    ],
  },
  {
    id: 5,
    name: 'Rowing',
    persian_name: 'پارو یی',
    child: [
      { id: 26, name: 'Regatta', persian_name: '', child: [] },
      { id: 27, name: 'Rowing', persian_name: '', child: [] },
    ],
  },
  {
    id: 6,
    name: 'Snow',
    persian_name: 'برفی',
    child: [
      { id: 28, name: 'Alpine Skiing', persian_name: '', child: [] },
      { id: 29, name: 'Nordic Skiing', persian_name: '', child: [] },
      { id: 30, name: 'Ski Mountaineering', persian_name: '', child: [] },
      { id: 31, name: 'Snowshoeing', persian_name: '', child: [] },
      { id: 32, name: 'Snow', persian_name: '', child: [] },
    ],
  },
  {
    id: 7,
    name: 'other',
    persian_name: 'سایر',
    child: [
      { id: 33, name: 'Adventure', persian_name: '', child: [] },
      { id: 34, name: 'OCR', persian_name: '', child: [] },
      { id: 35, name: 'Speed Skate', persian_name: '', child: [] },
      { id: 36, name: 'Other', persian_name: '', child: [] },
    ],
  },
];
